<template>
    <div ref="info_warning"></div>
</template>

<script>
import InfoWarning from "!!raw-loader!../../assets/ricoh_assets/icons/ICN003-04_info_warning.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.info_warning.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = InfoWarning

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>

</style>